import { IoClose } from "react-icons/io5";
import style from "./SuccessModal.module.scss";

export function SuccessModal({
    title,
    description,
    closeModal,
    button
}: {
    title: string,
    description: string | JSX.Element,
    closeModal?: () => void,
    button?: { text: string | JSX.Element, action: () => void }
}) {
    return (
        <div className={style.backing}>
            <div className={style.container}>
                <IoClose
                    className="absolute right-[15px] top-[15px] w-[15px] h-[15px] cursor-pointer"
                    onClick={closeModal}
                />
                <img src="/image/success.png" alt="success" />
                <div className={style.content}>
                    <p className={style.title}>{title}</p>
                    <div className={style.description}>{description}</div>
                    <button
                        type="button"
                        onClick={() => {
                            if (button) {
                                button?.action()
                            } else {
                                closeModal?.()
                            }
                        }}
                    >
                        {button?.text || "Продовжити"}
                    </button>
                </div>
            </div>
        </div>
    )
}